module.exports = __webpack_public_path__ + "img/9791189982331.95d4716b.jpg";